var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_vm._t("default"),_c('div',{staticClass:"absolute -top-1 h-3 -translate-y-1/2 left-3 px-1",class:[_vm.bg]},[_c('p',{staticClass:"text-xxs"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }